import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import PropTypes from "prop-types";
import { getPageShellDataSafely } from "@/services/contenful/getPageShellDataSafe";
import CompareSection from "@/components/CustomComponents/CompareSection";
const Loader = dynamic(() => import("@/components/loader"));

const LandingPage = ({
  pageData = {},
  locale = "en",
  compareMappingsData = {},
}) => {
  const router = useRouter();
  if (router.isFallback) {
    return <Loader loading={router.isFallback} />;
  }
  return (
    <CompareSection locale={locale} compareMappingsData={compareMappingsData} />
  );
};

export async function getServerSideProps({ params, preview, locale }) {
  const {
    items,
    headerNavigationData,
    footerNavigationData,
    promoBannerData,
    worldwideMenuData,
    compareMappingsData,
    apacConfigurationsData,
    translations,
  } = await getPageShellDataSafely({
    slug: `/compare`,
    preview,
    contentType: "brazilLandingPage",
    fetchEntryBySlugFlag: true,
    locale,
  });

  const pageData = items?.[0]?.fields || null;
  return {
    props: {
      pageData,
      headerNavigationData,
      footerNavigationData,
      promoBannerData,
      world: worldwideMenuData,
      compareMappingsData,
      apacConfigurationsData,
      translations,
      locale,
    },
  };
}

LandingPage.propTypes = {
  pageData: PropTypes.object,
  locale: PropTypes.string,
  compareMappingsData: PropTypes.object,
};

export default LandingPage;
